import { render, staticRenderFns } from "./AssociarProdutoKitDinamico.vue?vue&type=template&id=6b2de1b0"
import script from "./AssociarProdutoKitDinamico.vue?vue&type=script&lang=ts"
export * from "./AssociarProdutoKitDinamico.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports